import type { TableFilterTreeOptions } from "../table-filter.type";
import type { RiskItem } from "@/modules/risk";

import { useGetDefaultRiskLevelsWithNoRisk } from "@/entities/risk-matrix";
import { useAssetRisksReferential } from "@/modules/asset/asset-risk";
import { RiskBadge } from "@/modules/risk-badge";

export const useAssetsTableFilterRisk = () => {
  const { riskLevels } = useAssetRisksReferential();

  return useTableFilterRisk(riskLevels);
};

export const useObservationsTableFilterRisk = () => {
  const { riskLevels } = useGetDefaultRiskLevelsWithNoRisk();

  return useTableFilterRisk(riskLevels);
};

export const useTableFilterRisk = (
  riskLevels: RiskItem[]
): TableFilterTreeOptions => {
  const filters = riskLevels.map((riskLevel) => ({
    text: <RiskBadge risk={riskLevel} />,
    value: `${riskLevel.value}`,
  }));

  return {
    filterMode: "tree",
    filters,
  };
};
